import { createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';

// Email-link landing (signup confirmation + any other link-based session).
// detectSessionInUrl: true parses the URL hash asynchronously; we wait for the
// SIGNED_IN event before redirecting. A fixed setTimeout race-condition would
// consume the one-time token on slow networks and lock the user out of their
// session.

const AUTH_TIMEOUT_MS = 8_000;

export const Route = createFileRoute('/auth/callback')({
  beforeLoad: async () => {
    const session = await waitForSession();
    if (!session) throw redirect({ to: '/login' });
    throw redirect({ to: '/' });
  },
});

async function waitForSession(): Promise<unknown> {
  // Fast path: session already hydrated.
  const initial = await supabase.auth.getSession();
  if (initial.data.session) return initial.data.session;

  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      subscription.unsubscribe();
      resolve(null);
    }, AUTH_TIMEOUT_MS);

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        clearTimeout(timer);
        subscription.unsubscribe();
        resolve(session);
      }
    });
  });
}
